import { render, staticRenderFns } from "./AddCertificateTab.vue?vue&type=template&id=76067203&scoped=true&"
import script from "./AddCertificateTab.vue?vue&type=script&lang=js&"
export * from "./AddCertificateTab.vue?vue&type=script&lang=js&"
import style0 from "./AddCertificateTab.vue?vue&type=style&index=0&id=76067203&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76067203",
  null
  
)

export default component.exports